module.exports = __webpack_public_path__ + "static/media/YM06_7.89f59e8a.jpg";